
import axios from "axios";
import { API_BASE_URI } from "../../../redux/ApiCall";

export const checkerCall = (hash: string) => {
  return axios.get(API_BASE_URI + `/user/check/${hash}`);
};
